
/**
 * 系统管理
 */
export const loginUrl = '/admin/login'; //登录
export const signOut = '/admin/signOut'; //退出
export const userListAll = '/admin/listAll'; //用户列表
export const addOrUpdateUser = '/admin/addOrUpdate';  //添加OR编辑用户
export const updateSysModel = '/admin/updateSysModel'; //目录权限

export const getCaptcha = '/captcha/get'; //获取登录验证码

//后台目录
export const menuListAll = '/systemModel/listAll';
export const addOrUpdateMenuList = '/systemModel/addOrUpdate';
export const delMenuList = '/systemModel/del';
export const menuList = '/admin/listMenu';

//系统参数
export const getSysParamPageList = '/sysParam/getPageList';
export const addOrUpdateSysParam = '/sysParam/addOrUpdate';

//用户日志
export const getUserLogPageList = '/userLog/pageList';
// export const addUserLog = '/userLog/add';
export const addOrUpdateUserLog = '/userLog/addOrUpdate';
export const delUserLog = '/userLog/del';

//测试账号
export const getTestAccountList = '/testAccount/pageList';
export const addTestAccount = '/testAccount/add';
export const delTestAccount = '/testAccount/del';
export const updateAccountState = '/testAccount/updateState';

//推荐参数
export const getCoeffPageList = '/sys/pageCoeffList';
export const updateCoeffList = '/sys/updateCoeff';

//首页推荐参数
// export const getHomeRecommendCoeff = '/sys/getHomeRecommendCoeff';
export const getHomeRecommendCoeff = '/sys/getCoeff';


//首页推荐参数
export const getSysConfig = '/sys/getConfig';

/**
 * 公共模块
 */

// export const sendSystemMessage = '/rcIm/send'; //发送系统消息
export const sendSystemMessage = '/rcim/sendAssistant'; //发送系统消息
export const commonSearchResumeDetail = '/resume/commonSearchResumeDetail'; //搜索简历详情
export const getUserDetailInfo = '/resume/getDetailInfo'; //昵称-简历弹框
export const areaList = '/area/list'; //省市
// export const channelList = '/channelPackage/listChannel'; //当前用户渠道列表
// export const listPackageNameAndChannel = '/common/listPackageNameAndChannel'; //当前用户渠道列表
export const listPackageNameAndChannel = '/channelPackage/listChannelPackage'; //当前用户渠道列表
// export const addBannedChat = '/bannedChat/addBannedChat'; //禁言
export const ipCityAbnormalList = '/ip/pageIpCityAbnormalList'; //用户异常ip列表
export const updateIpCityAbnormalState = '/ip/updateIpCityAbnormalState'; //更新ip异常状态
// export const getAllChannelList = '/channel/listChannel'; //获取渠道列表
export const getAllChannelList = '/channelPackage/listChannel'; //获取渠道列表

//小计
export const getUserSmallRemark = '/userSmallRemark/pageList';
export const addUserSmallRemark = '/userSmallRemark/add';

//视频
export const getAuthVideoInfo = '/authVideo/getPlayInfo';

// /**
//  * review 审核管理
//  */
//
//相册审核
export const getPhotoPageList = '/photo/pageList';
// export const pageImgList = '/photo/pageImgList';
export const updatePhotoState = '/photo/updateState';
//
//信息审核
export const getResumePageList = '/resume/pageList';
export const getResumeHeadImgList = '/resume/pageHeadImgList';
export const updateResumeState = '/resume/updateState';
// export const updateShowState = '/resume/updateShowState';
export const updateResumeInfo = '/resume/updateResume';
// export const updatePairState = '/resume/updatePairState';
export const updateUserBannedChat = '/resume/updateUserBannedChat';//更新禁言
export const updateUserForbidden = '/resume/updateUserForbidden';//更新用户警告、异常、封号状态(已替换成下面两个接口)
export const updateForbiddenState = '/resume/updateForbidden';//更新用户封号状态
export const updateAbnormalState = '/resume/updateAbnormal';//更新用户异常状态
export const updateScreenState = '/resume/updateScreenState';//屏蔽
export const updateResumeRecheckAuth = '/resume/updateResumeRecheckAuth';//指定认证
export const updateResumeCancelAuth = '/resume/updateResumeCancelAuth';//系统指定认证
export const getPlainInfo = '/resume/getPlain';//获取敏感性信息明文
export const updateResumeDelState = '/resume/updateDel';//展示、隐藏、注销
export const updateUserIdfaBan = '/resume/updateUserIdfaBan';//冻结/解冻用户设备
export const updateResumeOpenState = '/resume/updateOpenState';//更新公开状态
export const updateResumePdescState = '/resume/updatePdesc';//更新自我介绍
export const updateRecommendScore = '/resume/updateRecommendScore';//更新自我介绍
export const updateResumeQualityState = '/resume/updateQualityState';//优质用户
export const updateResumeUserSetting = '/resume/updateUserSetting';//首页推荐
//评分
export const getScoreList = '/score/list';//分数列表
export const updateResumeScore = '/score/updateResumeScore';//更新简历评分
//专区
export const getSpecialsList = '/specials/list';//列表
export const addUserSpecials = '/specials/addUserSpecials';//添加用户到专区
export const delUserSpecials = '/specials/delUserSpecials';//删除用户专区
//发送代金券
export const getVoucherSysList = '/voucher/listVoucherSys';
export const sendVoucherByUser = '/voucher/sendVoucherByUser';

//身份证审核
export const getIdentityPageList = '/identity/pageList';//列表
export const updateIdentityState = '/identity/updateState';//更新状态
export const getIdentityQuicklyPageList = '/identity/pageQuicklyList';//快审页面
export const getRepeatIdentityList = '/identity/listRepeatIdentity';//身份证重复用户列表
export const updateCertifyState = '/identity/updateCertifyState';//更新芝麻、百度认证状态

//
// //提现列表
// export const getWithdrawalList = '/integral/withdrawalList';
// export const updateWithdrawalState = '/integral/updateState';


//用户管理
export const getUserPageList = '/resume/pageUserList';
export const getCommonSysParam = '/sysParam/getCommon'; //获取常用系统参数
export const updateConfigSysParam = '/sysParam/updateConfig'; //更新系统参数值
export const updateUserCustomerState = '/userCustomer/updateState'; //更新跟进人状态

/**
 * gift 礼物
 */
export const getGiftPageList = '/gift/pageList';
export const updateGiftState = '/gift/updateState';
export const addOrUpdateGift = '/gift/addOrUpdate';
export const updateSysGift = '/gift/updateSys';
export const updateDefaultGift = '/gift/updateDefault';

/**
 * background 背景图
 */
export const getBackGroundPageList = '/background/pageList';
export const updateBackGroundState = '/background/updateState';
export const addOrUpdateBackGround = '/background/addOrUpdate';

/**
 * feedback 意见反馈
 */
export const getAdvicePageList = '/advice/pageList';
export const updateAdviceReadState = '/advice/updateRead';
export const addOrUpdateAdviceSort = '/advice/addOrUpdateSort';
export const getAdviceListSort = '/advice/listSort';

/**
 * feedback 举报管理
 */
export const getReportPageList = '/report/pageList';
export const updateReportState = '/report/updateState';

/**
 * feedback 违规通报
 */
export const getIllegalNoticePageList = '/illegalNotice/pageList';
export const updateIllegalNoticeShow = '/illegalNotice/updateShow';
export const addOrUpdateIllegalNotice = '/illegalNotice/addOrUpdate';

/**
 * gold 金币价格
 */
export const getGoldPricePageList = '/gold/pagePriceList';
export const saveOrUpdateGoldPrice = '/gold/priceUpdateOrAddData';
export const getGoldPriceChannelList = '/gold/priceChannelList';

// /**
//  * gold 金币明细
//  */
export const getGoldDetailType = '/gold/goldTypeList';
export const getGoldDetailPageList = '/gold/pageGoldBillDetailList';
export const goldGiveAwayOrDeduct = '/gold/goldGiveAwayOrDeduct';
// export const goldSummaryCurrentStat = '/goldBillDetail/currentStat';
//
// /**
//  * integral 积分明细
//  */
// export const getIntegralDetailType = '/integral/getIntegralDetailType';
// export const getIntegralDetailList = '/integral/detailList';
// export const systemUpdateIntegralBalance = '/integral/systemUpdateIntegralBalance';
// export const integralSummaryCurrentStat = '/integral/currentStat';
//
// /**
//  * reward 奖励管理
//  */
// export const getAwardSettingList = '/awardSetting/listAll';
// export const updateAwardSetting = '/awardSetting/update';
//
// /**
//  * chennel 渠道/版本
//  */
//版本管理
export const getVersionPageList = '/version/pageList';
export const addOrUpdateVersion = '/version/addOrUpdate';
export const updateVersionDel = '/version/updateDel';
export const updateVersionAlive = '/version/updateAlive';
export const updateVersionPayType = '/version/updatePayType';
export const getVersionListChannel = '/version/listChannel';
//产品方案渠道控制
// export const getChannelPowerConfigPageList = '/channel/pageChannelPowerConfigList';
export const getChannelPowerConfigPageList = '/channelPackage/pageChannelPackageList';
export const channelPowerConfigPackageNames = '/channel/channelPowerConfigPackageNames';
// export const updateChannelPowerConfig = '/channel/updateChannelPowerConfig';
export const updateChannelPowerConfig = '/channelPackage/updateChannelPackage';
export const syncChannelPowerConfig = '/channel/syncChannelPowerConfig';

//
/**
 * tjChannel 渠道数据
 */
export const getTjChannelPageList = '/tj/pageIncomeList';
export const getTjChannelSummary = '/tj/pageSummary';
export const tjChannelList = '/tj/listSelectChannel';
export const getTjChannelNow = '/tj/pageNowIncomeList';
export const addTjDayRemark = '/tj/addTjDayRemark';
//开通数据
export const gettVipStatLis = '/routeTransform/listVipStat';
export const getMarriageStatList = '/routeTransform/listMarriageStat';
export const updateRouteTransformRemark = '/routeTransform/updateRemark';
//
// /**
//  * sysTag 果购城微信管理
//  */
// export const getGgPageList = '/guogou/pageList';
// export const viewGgNumPageList = '/guogou/viewNumPageList';
// export const addOrUpdateGgWx = '/guogou/addOrUpdate';
// export const updateGgWxState = '/guogou/updateState';
// export const updateGgWxDefault = '/guogou/updateDefault';
//
/**
 * sys
 */
//信息标签
export const getSysTagPageList = '/sys/pageTagList';
export const addOrUpdateSysTag = '/sys/addOrUpdateTag';
export const updateSysTagState = '/sys/updateTagState';
//系统默认昵称
export const getSysNicknamePageList = '/sys/pageNicknameList';
export const addOrUpdateSysNickname = '/sys/updateNickname';
export const uploadNicknameExcel = '/sys/uploadNicknameExcel';

/**
 * chat 聊天管理
 */

//快捷问候语
export const getGreetingPageList = '/sysGreeting/pageList';
export const addOrUpdateGreeting = '/sysGreeting/addOrUpdate';
export const updateGreetingState = '/sysGreeting/updateState';
export const updateGreetingTop = '/sysGreeting/updateTop';

//聊天内容
export const getChatContentPageList = '/rcImHistory/pageList';
export const updateInteractState = '/rcImHistory/updateInteractStat';//审查
export const getChatUserPageList = '/rcImHistory/pageUserList'; //单用户对应的聊天用户列表
export const getUserChatContentPageList = '/rcImHistory/pageUserChatList'; //两个用户间聊天内容列表
export const getUserChatResume = '/rcImHistory/getUserChatResume';//获取聊天/纸条双方简历
export const getMsgUserPageList = '/msg/pageUserList'; //单用户对应的纸条用户列表
export const getUserMsgContentPageList = '/msg/pageUserMsgList'; //两个用户间纸条内容列表

//聊天内容监控
export const getChatMonitorPageList = '/rcImHistory/pageChatMonitorList';
export const getUserWarnPageList = '/common/pageWarnMsgList'; //单个用户警告记录
export const getBannedHistoryPageList = '/common/pageBannedChatList'; //单个用户禁言操作历史记录
export const getReportUserPageList = '/report/pageUserList'; //单个用户被举报历史记录
export const getAbnormalChatList = '/rcImHistory/pageUserViolationList'; //单用户聊天内容违规列表

//聊天触发
export const getChatViolationPageList = '/rcImHistory/pageChatViolationList';
export const getChatViolationUserPageList = '/rcImHistory/pageChatViolationToUserList';

//黑名单词库
export const getBlockRulePageList = '/blockRule/pageList';
export const addOrUpdateBlockRule = '/blockRule/addOrUpdate';
export const delBlockRule = '/blockRule/del';
export const updateBlockRuleSpecial = '/blockRule/updateSpecial';
export const listBlockRuleSpecial = '/blockRule/listSpecial'; //获取重点关键词列表

//推送管理
export const getPushPageList = '/push/pageList';
export const addOrUpdatePushList = '/push/addOrUpdate';
export const updatePushState = '/push/updateState';

// /**
//  * voice 语音参考内容
//  */
// export const getReferencePageList = '/voiceReference/pageList';
// export const addOrUpdateReference = '/voiceReference/addOrUpdate';
// export const updateReferenceState = '/voiceReference/updateState';
//
// /**
//  * voice 语音审核
//  */
// export const getVoicePageList = '/voice/pageList';
// export const updateVoiceState = '/voice/updateState';
//
/**
 * dynamic 动态审核
 */
export const getZonePageList = '/zone/pageList';
export const getVedioPlayInfo = '/zone/getPlayInfo';
export const updateZoneImgDel = '/zone/updateZoneImgDel';
export const updateZoneState = '/zone/updateState';
export const updateQualityZoneState = '/zone/updateQualityState';
export const updateZoneTopState = '/zone/updateZoneTop';
//动态互动管理
export const getZoneInteractPageList = '/zone/pageDynamicList';
export const updateZoneInteractState = '/zone/updateDynamicState';
//话题管理
export const getZoneTopicList = '/zone/pageTopicList';
export const addOrUpdateZoneTopic = '/zone/addOrUpdateTopic';
export const updateZoneTopicState = '/zone/updateTopicState';

//官方动态
export const getOfficialInfo = '/zone/getOfficialInfo';
export const updateOfficialInfo = '/zone/updateOfficialInfo';
export const getOfficialPageList = '/zone/pageOfficialList';
export const updateOfficialState = '/zone/updateOfficialState';
export const addOrUpdateOfficial = '/zone/addOrUpdateOfficial';
export const getTopicList = '/zone/listTopic';

//官方动态互动
export const getOfficialInteractPageList = '/zone/pageOfficialInteractionList';
export const getOfficialMsgPageList = '/zone/pageOfficialMsgList';
export const officialReply = '/zone/officialReply';
//
/**
 * invite 进入管理
 */
// export const getInvitePageList = '/invite/pageList';
// export const getInviteUserPageList = '/invite/pageUserList';
//邀请图片
export const qrCodeChannelList = '/invite/qrCodeChannelList';
export const getInviteQrCodePageList = '/invite/pageInviteQrCodeList';
export const updateQrCodeImgState = '/invite/updateQrCodeImgState';
export const addOrUpdateQrCodeImg = '/invite/addOrUpdateQrCodeImg';
export const createQrCodeImg = '/invite/createQrCodeImg';
export const updateQrCodeImgRemark = '/invite/updateQrCodeImgRemark';
//邀请码搜索
export const inviteCodeSearch = '/invite/inviteCodeSearch';
export const inviteCodeSearchSubordinate = '/invite/inviteCodeSearchSubordinate';
// /**
//  * ios-review IOS审核版
//  */
//
// //纸条
// export const getScripPageList = '/scrip/pageList';
// export const addOrUpdateScrip = '/scrip/addOrUpdate';
// export const updateScripState = '/scrip/updateState';
// export const addScripImg = '/scrip/addImg';
// export const delScripImg = '/scrip/delImg';
// export const pageCommentList = '/scrip/pageCommentList';
// export const addOrUpdateComment = '/scrip/addOrUpdateComment';
// export const updateCommentState = '/scrip/updateCommentState';
//
// //情感广场
// export const getEmotionSharePageList = '/emotionShare/pageList';
// export const addOrUpdateEmotionShare = '/emotionShare/addOrUpdate';
// export const updateEmotionShareState = '/emotionShare/updateState';


/**
 * vip vip管理
 */

//套餐管理
export const getVipPageList = '/vip/pageList';
export const addOrUpdateVipList = '/vip/addOrUpdate';
// export const updateVipDel = '/vip/updateDel';
export const updateVipState = '/vip/updateState';
export const getIosChannelList = '/vip/listIosChannel';
export const updateDefaultVip = '/vip/updateDefault';
export const updateVipExperienceState = '/vip/updateExperienceState';
//用户管理
export const getVipUserPageList = '/vip/pageUserList';
export const updateVipUserExpire = '/vip/updateExpire';
export const getVipUserDtList = '/vip/pageDtList';
export const getVipAllList = '/vip/listAll';
export const getSearchBillInfo = '/common/searchBill';

//会员特权
export const getVipPrivilegePageList = '/vip/pagePrivilegeList';
export const updateVipPrivilege = '/vip/updatePrivilege';
export const updateVipPrivilegeState = '/vip/updatePrivilegeState';

/**
 * greeting 打招呼
 */

//互动数据
export const getInitiatorPageList = '/greeting/pageInitiatorList';
export const getYesterdayStat = '/greeting/yesterdayStat'; //昨日自动打招呼统计
export const getReceiverPageList = '/greeting/pageReceiverList';
export const getGreetingDateNumList = '/greeting/pageDateNumList';//用户招呼日期-数量列表
export const getGreetingDateUserList = '/greeting/pageDateUserList';//日期对应招呼列表
export const getUserLoveDateNumList = '/userLove/pageDateNumList';//用户心动日期-数量列表
export const getUserLoveDateUserList = '/userLove/pageDateUserList';//日期对应心动列表
export const getUserVisitDateNumList = '/userVisit/pageDateNumList';//用户来访日期-数量列表
export const getUserVisitDateUserList = '/userVisit/pageDateUserList';//日期对应来访列表

//打招呼用语
export const getGreetingTermPageList = '/greeting/pageList';
export const updateGreetingTermState = '/greeting/updateState';
export const updateGreetingTermRecommendState = '/greeting/updateRecommendState';
export const getReceiverPageSummary = '/greeting/pageReceiverSummary';

/**
 * interact 互动管理
 */
//纸条审核页面
export const getMsgPageList = '/msg/pageDtList';
export const updateMsgDtState = '/msg/updateDtState';

//配对列表
export const getOnlineChatPageList = '/chat/pageOnlineChatList';




/**
 * auth 认证管理
 */

export const getAuthCarPageList = '/authCar/pageList';//车辆
export const updateAuthCar = '/authCar/updateAuthCar';
export const delAuthCarData = '/authCar/delAuthData';

export const getAuthEduPageList = '/authEdu/pageList';//学历
export const updateAuthEdu = '/authEdu/updateAuthEdu';
export const delAuthEduData = '/authEdu/delAuthData';
export const updateStateChsi = '/authEdu/updateStateChsi';

export const getAuthHousePageList = '/authHouse/pageList';//房屋
export const updateAuthHouse = '/authHouse/updateAuthHouse';
export const delAuthHouseData = '/authHouse/delAuthData';

export const getAuthJobPageList = '/authJob/pageList';//职业
export const updateAuthJob = '/authJob/updateAuthJob';
export const delAuthJobData = '/authJob/delAuthData';

export const getAuthVideoPageList = '/authVideo/pageList';//视频
export const bathUpdateAuthVideo = '/authVideo/bathUpdateAuthVideo';


/**
 * wechat 微信管理
 */

//微信审核
export const getWeChatPageList = '/weChat/pageList';
export const batchUpdateWeChatState = '/weChat/batchUpdateWeChatState';
export const batchUpdateWeChatShowState = '/weChat/batchUpdateWeChatShowState';
export const getThroughCodeList = '/weChat/listThroughCode';
export const getCopyNumPageList = '/weChat/pageCopyNumList';
export const updateWeChatHideState = '/weChat/updateHideState';
//红娘微信管理
export const getMarriageWeChatPageList = '/marriageWeChat/pageList';
export const addOrUpdateMarriageWeChat = '/marriageWeChat/addOrUpdate';
export const updateMarriageWeChatState = '/marriageWeChat/updateState';
export const updateMarriageWeChatDefaultState = '/marriageWeChat/updateDefaultState';
export const marriageWeChatCopyNumList = '/marriageWechatRecord/pageCopyNumList';
export const marriageWeChatCopyUserInfo = '/marriageWechatRecord/pageCopyUserInfo';
//红娘微信管理-通过码
export const getThroughCodeWeChatPageList = '/marriageThroughCodeWeChat/pageList';
export const addOrUpdateThroughCodeWeChat = '/marriageThroughCodeWeChat/addOrUpdate';
export const updateThroughCodeWeChatState = '/marriageThroughCodeWeChat/updateState';
export const updateThroughCodeWeChatDefaultState = '/marriageThroughCodeWeChat/updateDefaultState';
export const throughCodeWeChatCopyNumList = '/marriageThroughCodeRecord/pageCopyNumList';
export const throughCodeWeChatCopeUserInfo = '/marriageThroughCodeRecord/pageCopyUserInfo';
//红娘消息管理
export const getMatcherMsgPageList = '/matcherMsg/pageList';
export const addOrUpdateMatcherMsg = '/matcherMsg/addOrUpdate';
export const updateMatcherMsgState = '/matcherMsg/updateState';
//红娘短信管理
export const getMatchmakerSmsPageList = '/matchmakerSms/pageList';
export const addOrUpdateMatchmakerSms = '/matchmakerSms/addOrUpdate';
export const updateMatchmakerSmsState = '/matchmakerSms/updateState';

//微信下载记录
export const getWechatDownloadPageList = '/weChat/pageDownloadList';
export const getWechatDownloadUserPageList = '/weChat/pageDownloadUserList';


/**
 * banner banner管理
 */
//vip banner
export const getVipBannerPageList = '/banner/pageVipBannerList';
export const addOrUpdateVipBanner = '/banner/addOrUpdateVipBanner';
export const updateVipBannerState = '/banner/updateVipBannerState';
export const addVipBannerImg = '/banner/addVipBannerImg';

//首页 banner
export const getHomeBannerPageList = '/banner/pageHomeBannerList';
export const addOrUpdateHomeBanner = '/banner/addOrUpdateHomeBanner';
export const updateHomeBannerState = '/banner/updateHomeBannerState';
export const addHomeBannerImg = '/banner/addHomeBannerImg';

//首页 icon
export const getHomeIconPageList = '/banner/pageHomeTopList';
export const addOrUpdateHomeIcon = '/banner/addOrUpdateHomeTop';
export const updateHomeIconState = '/banner/updateHomeTopState';
export const updateHomeTopSendNotification = '/banner/updateHomeTopSendNotification';
export const updateHomeTopSendNewcomerPrompt = '/banner/updateHomeTopSendNewcomerPrompt';

//发现 banner
export const getDiscoveryBannerPageList = '/banner/pageDiscoveryBannerList';
export const updateDiscoveryBannerState = '/banner/updateDiscoveryBannerState';
export const addOrUpdateDiscoveryBannerImg = '/banner/addOrUpdateDiscoveryBannerImg';
export const addOrUpdateDiscoveryBanner = '/banner/addOrUpdateDiscoveryBanner';

/**
 * single 一对一服务
 */
//脱单服务
export const getOneToOneUrlPageList = '/oneToOneUrl/pageList';
export const addOrUpdateOneToOneUrl = '/oneToOneUrl/addOrUpdate';
export const updateOneToOnePayType = '/oneToOneUrl/updatePayType';
//一对一服务价格列表
export const getServicePricePageList = '/oneToOneServicePrice/getList';
export const addOrUpdateServicePrice = '/oneToOneServicePrice/addOrUpdate';
export const delOneToOnePriceInfo = '/oneToOneServicePrice/delOneToOnePriceInfo';

//脱单圈
export const getSingleReleasePageList = '/cdtctdCoil/pageOfficialList';
export const updateSingleState = '/cdtctdCoil/updateState';
export const addOrUpdateSingleRelease = '/cdtctdCoil/addOrUpdate';
export const updateSingleQualityState = '/cdtctdCoil/updateQualityState';
export const uploadSinglePortrait = '/cdtctdCoil/uploadPortrait';

export const getSingleReviewPageList = '/cdtctdCoil/pageUserList';

//订单列表
export const getOneToOneApplyPageList = '/oneToOneApply/pageList';
export const updateOneToOneApplyRemark = '/oneToOneApply/updateRemark';

/**
 * img-info 图片信息编辑
 */
//脱单服务
export const getUserImgInfoPageList = '/userImgInfo/pageList';
export const addOrUpdateUserImgInfo = '/userImgInfo/addOrUpdate';
export const bindingUserImgInfo = '/userImgInfo/bindingUser';

//IP访问记录页面
export const getIpVisitPageList = '/ip/pageVisitList';


/**
 * score 评分管理
 */
//脱单服务
export const getScorePageList = '/score/pageList';
export const addOrUpdateScore = '/score/addOrUpdate';
export const updateScoreState = '/score/updateState';

/**
 * sms 短信管理
 */
//验证码
export const getSmsVerifyPageList = '/sms/getPageList';
export const addSmsVerify = '/sms/add';
//激活短信管理
export const getActivationSmsPageList = '/sms/pageActivationSmsList';
export const addOrUpdateActivationSms = '/sms/addOrUpdateActivationSms';
export const updateActivationSmsStatus = '/sms/updateActivationSmsStatus';
export const getActivationSmsChannelPackage = '/sms/getActivationSmsChannelPackage';
export const getAddOrUpdateChannelPackage = '/sms/getAddOrUpdateChannelPackage';
//渠道短信签名
export const getSubmailConfigPageList = '/sms/pageSubmailConfigList';
export const addOrUpdateSubmailConfig = '/sms/addOrUpdateSubmailConfig';
export const updateStateSubmailConfig = '/sms/updateStateSubmailConfig';

/**
 * love 三行情书
 */
//三号情书
export const getLoveLetterPageList = '/loveLetter/pageList';
export const addOrUpdateLoveLetter = '/loveLetter/addOrUpdate';
export const addLoveLetterImg = '/loveLetter/addLoveLetterImg';
export const updateLoveLetterState = '/loveLetter/updateState';
//留言管理
export const getLoveMsgPageList = '/loveMsg/pageList';
export const updateLoveMsgState = '/loveMsg/updateState';
export const replyLoveMsg = '/loveMsg/replyMsg';
//投稿管理
export const getLoveSubmitPageList = '/loveSubmit/pageList';
export const updateLoveSubmitState = '/loveSubmit/updateState';
export const getLoveSubmitSortList = '/loveSubmit/sortList';
export const addOrUpdateLoveSubmitSortList = '/loveSubmit/addOrUpdate';

/**
 * talent 活跃达人
 */
//达人审核
export const getApplyPageList = '/talent/pageApplyList';
export const updateApplyStatus = '/talent/updateApplyStatus';
export const updateApplyRecommend = '/talent/updateApplyRecommend';
export const updateApplyNewUserShow = '/talent/updateApplyNewUserShow';
export const sendApplyNotify = '/talent/sendApplyNotify';
//达人积分统计
export const getIntegralPageList = '/talent/pageIntegralList';
export const updateTalentIntegral = '/talent/updateTalentIntegral';
export const listIntegralType = '/talent/listIntegralType';
//达人提现
export const getAwardPageList = '/talent/pageAwardList';
export const updateAwardStatus = '/talent/updateAwardStatus';
export const getPageAwardSummary = '/talent/pageAwardSummary';

//达人奖品
export const getPrizePageList = '/talent/pagePrize';
export const updatePrize = '/talent/updatePrize';
export const forcedUpdatePrize = '/talent/forcedUpdatePrize';

//更新达人关注状态
export const updateTalentFcousState = '/talent/updateFcousState';

//积分奖励管理页面
export const getIntegralRulePageList = '/talent/pageIntegralRuleList';
export const updateIntegralRule = '/talent/updateIntegralRule';


/**
 * marriage 婚恋服务
 */
//套餐管理
export const getMarriagePageList = '/marriage/pageList';
export const getMarriageListChannel = '/marriage/listChannel';
export const addOrUpdateMarriage = '/marriage/addOrUpdate';
// export const updateMarriageDel = '/marriage/updateDel';
export const updateMarriageState = '/marriage/updateState';
export const updateMarriageDefault = '/marriage/updateDefault';
export const sendMarriageSms = '/marriage/sendSms';
export const updateMarriageExperienceState = '/marriage/updateExperienceState';

//用户管理
export const getMarriagePageUserList = '/marriage/pageUserList';
export const updateMarriageUserExpire = '/marriage/updateExpire';
export const getMarriagePageDtList = '/marriage/pageDtList';
export const getMarriageAllList = '/marriage/listAll';

//牵线服务
export const getMatcherPageList = '/matcher/pageList';
export const updateMatcherState = '/matcher/updateState';
export const updateMatcherRemark = '/matcher/updateRemark';

//用户置顶
export const getUserTopPageList = '/user/pageUserTopList';
export const updateUserTopState = '/user/updateUserTopState';

/**
 * voucher 代金券
 */
//代金券管理
export const getVoucherSysPageList = '/voucher/pageVoucherSysList';
export const addOrUpdateVoucherSys = '/voucher/addOrUpdateVoucherSys';
export const updateVoucherSysAward = '/voucher/updateVoucherSysAward';
export const updateVoucherSysDel = '/voucher/updateVoucherSysDel';
export const updateVoucherSysNewbie = '/voucher/updateVoucherSysNewbie';
export const updateVoucherSysShare = '/voucher/updateVoucherSysShare';
export const updateVoucherSysVip = '/voucher/updateVoucherSysVip';


/**
 * special 专区管理
 */
export const getSpecialsSysPageList = '/specials/pageList';
export const addOrUpdateSpecials = '/specials/addOrUpdate';
export const updateSpecialsState = '/specials/updateState';
export const updateSpecialsColour = '/specials/updateColour';

/**
 * task 任务中心
 */
export const getTaskCenterPageList = '/taskCenter/pageList';
export const updateTaskCenterInfo = '/taskCenter/update';

/**
 * area 地区管理
 */
//先逛逛城市
export const getRecommendCityList = '/area/listRecommendCity';
export const addRecommendCity = '/area/addRecommendCity';
export const updateRecommendCityDel = '/area/updateRecommendCityDel';

/**
 * success 成功案例
 */
//成功案例管理
export const getSuccessfulCasePageList = '/successfulCase/pageList';
export const addOrUpdateSuccessfulCase = '/successfulCase/addOrUpdate';
export const updateSuccessfulCaseState = '/successfulCase/updateState';
export const updateSuccessfulCaseOrderNum = '/successfulCase/updateOrderNum';
export const uploadSuccessfulCaseImg = '/successfulCase/uploadImg';
//文章留言管理
export const getSuccessfulCommentPageList = '/successfulCase/pageCommentList';
export const updateSuccessfulCommentState = '/successfulCase/updateCommentState';
export const updateSuccessfulCommentReply = '/successfulCase/updateCommentReply';

/**
 * third 渠道商结算
 */
export const getThirdSettlementPageList = '/thirdSettlement/pageList';
export const addOrUpdateThirdSettlement = '/thirdSettlement/addOrUpdate';
export const updateThirdSettlementState = '/thirdSettlement/updateState';
export const updateThirdSettlementDel = '/thirdSettlement/updateDel';

//相亲报名
export const getMiaiPageList = '/miai/pageList';
export const updateMiaiState = '/miai/updateState';
export const updateMiaiRemark = '/miai/updateRemark';
export const exportMiaiExcel = '/miai/exportExcel';
export const uploadMiaiImg = '/miai/uploadImg';
export const delMiaiImg = '/miai/delImg';

/**
 * img 系统头像
 */
export const getSysHeadPageList = '/sys/pageHeadList';
export const addOrUpdateSysHead = '/sys/addOrUpdateHead';
export const updateSysHeadState = '/sys/updateHeadState';

/**
 * sys/warm-tip 温馨提示
 */
export const getSysWarmTipPageList = '/warmTip/pageList';
export const updateSysWarmTipState = '/warmTip/updateState';
export const updateOrAddSysWarmTip = '/warmTip/updateOrAddData';

/**
 * sys/question 问题集
 */
export const getProblemSetPageList = '/problemSet/pageList';
export const updateProblemSetState = '/problemSet/updateState';
export const updateOrAddProblemSet = '/problemSet/updateOrAddData';

/**
 * sys/tag-info 信息标签（主页）I
 */
export const getInfoLabelPageList = '/infoLabel/pageList';
export const updateInfoLabelState = '/infoLabel/updateState';
export const updateOrAddInfoLabel = '/infoLabel/addOrUpdate';
export const getInfoLabelTypePageList = '/infoLabel/listAllType';
export const updateInfoLabelTypeState = '/infoLabel/updateTypeState';
export const addOrUpdateInfoLabelType = '/infoLabel/addOrUpdateType';

/**
 * sys/through-code 通过码-入口权限管理
 */
export const getThroughCodeLastRecord = '/throughCodeConditions/lastRecord';
export const addThroughCodeData = '/throughCodeConditions/addData';

/**
 * data/abnormal-order 异常订单号
 */
export const getAbnormalOrderPageList = '/abnormalOrderInfo/pageList';
export const uploadAbnormalOrders = '/abnormalOrderInfo/uploadAbnormalOrders';

/**
 * setting/alipay 阿里账号
 */
export const getAlipayPayPageList = '/alipayPay/pageList';
export const updateAlipayState = '/alipayPay/updatePayState';
export const changeUserPhone = '/user/changePhone';

/**
 * setting/wechat 微信账号配置
 */
export const getWxPayPageList = '/wxPay/pageList';
export const updateWxPayState = '/wxPay/updateState';

/**
 * fee/deposit 资金返回
 */
export const getBaoApplyPageList = '/returnFee/pageBaoApplyList';
export const updateBaoApplyState = '/returnFee/updateBaoApplyState';
export const getAllBaoAplly = '/returnFee/getAllBaoAplly';
export const returnAllBaoAplly = '/returnFee/returnAllBaoAplly';

//渠道包名
export const getChannelPageList = '/channelPackage/pageChannelList';
export const updateChannelInfo = '/channelPackage/updateChannel';
export const getPackageNamePageList = '/channelPackage/pagePackageNameList';
export const updatePackageNameInfo = '/channelPackage/updatePackageName';

//免费进入
export const getFreeUserEnterPageList = '/user/pageFreeUserEnterList';
export const listUserChannelDt = '/user/listUserChannelDt';

//广告配置
export const getSysAdConfig = '/sys/getAdConfig';
export const updateSysAdConfig = '/sys/updateAdConfig';

//渠道分析
export const getEnterCheckPageList = '/user/pageUserEnterCkeckList';
export const updateUserEnterCkeckState = '/user/updateUserEnterCkeckState';

//注册、登录短信次数限制清除
export const clearSmsSendNumber = '/sms/clearSmsSendNumber';

//其他审核项
export const getPerfectPageList = '/resume/pagePerfectList';
export const updatePerfectState = '/resume/updatePerfectState';

//模拟器记录
export const getEmulatorPageList = '/emulator/pageUserList';
export const getEmulatorDetailPageList = '/emulator/pageDetailList';

//推荐统计
export const getRecommendStatPageList = '/recommendStat/pageStatDateList';
export const getRecommendUserList = '/recommendStat/pageRecommendUserList';
export const getChatSecretUserList = '/recommendStat/pageChatSecretUserList';
export const getEachLoveUserList= '/userLove/pageEachLoveUserList';
export const getUserVisitList= '/userVisit/pageUserList';
export const getUserGoldList= '/gold/pageUserList';

//关注用户
export const updateResumeFocusState = '/resume/updateFocusState';
